import React from 'react'
// import {useIntl} from 'react-intl'
// import { KTIcon } from '../../../../helpers';
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/Auth'

const SidebarMenuMain = () => {
  // const intl = useIntl()
  const { currentUser } = useAuth()

  return (
    <>
      {/* User Monitoring (dashboard) — ALL roles */}
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title='User Monitoring'
        imgSrc='/assets/media/sidebar/crop monitoring dash.svg'
        whiteImgSrc='/assets/media/sidebar/sidebar_white/crop_monitoring_white.svg'
      />

      {/* User Onboarding — Admin, Operations, Sales (NOT Agronomist) */}
      {(currentUser?.role === 'Admin' ||
        currentUser?.role === 'Operations' ||
        currentUser?.role === 'Sales') && (
          <SidebarMenuItem
            to='/user-onboarding'
            icon='element-11'
            title='User Onboarding'
            imgSrc='/assets/media/sidebar/users.svg'
            whiteImgSrc='/assets/media/sidebar/sidebar_white/users.svg'
          />
        )}

      {/* S6 Activation — Admin, Operations */}
      {(currentUser?.role === 'Admin' || currentUser?.role === 'Operations') && (
        <SidebarMenuItem
          to='/s6-activation'
          icon='element-11'
          title='S6 Activation'
          imgSrc='/assets/media/sidebar/update subscription.svg'
          whiteImgSrc='/assets/media/sidebar/sidebar_white/update_subscription_white.svg'
        />
      )}

      {/* IoT Device Mapping — Admin, Operations, Agronomist */}
      {(currentUser?.role === 'Admin' ||
        currentUser?.role === 'Operations' ||
        currentUser?.role === 'Agronomist') && (
          <SidebarMenuItem
            to='/iot-device-mapping'
            icon='element-11'
            title='IoT Device Mapping'
            imgSrc='/assets/media/sidebar/iot_mapping.svg'
            whiteImgSrc='/assets/media/sidebar/sidebar_white/iot_mapping_white.svg'
          />
        )}

      {/* Update Subscription — Admin, Operations */}
      {(currentUser?.role === 'Admin' || currentUser?.role === 'Operations') && (
        <SidebarMenuItem
          to='/update-subscription'
          icon='element-11'
          title='Update Subscription'
          imgSrc='/assets/media/sidebar/update subscription.svg'
          whiteImgSrc='/assets/media/sidebar/sidebar_white/update_subscription_white.svg'
        />
      )}

      {/* Admin-only features */}
      {currentUser?.role === 'Admin' && (
        <>
          <SidebarMenuItem
            to='/api-usage'
            icon='element-11'
            title='API Usage'
            imgSrc='/assets/media/sidebar/api usage.svg'
            whiteImgSrc='/assets/media/sidebar/sidebar_white/api_usage_white.svg'
          />

          <SidebarMenuItem
            to='/customer-interaction'
            icon='element-11'
            title='Customer Interaction'
            imgSrc='/assets/media/sidebar/add on.svg'
            whiteImgSrc='/assets/media/sidebar/sidebar_white/add_on_white.svg'
          />

          <SidebarMenuItem
            to='/lead-management'
            icon='element-11'
            title='Lead Management'
            imgSrc='/assets/media/sidebar/lead_managment.svg'
            whiteImgSrc='/assets/media/sidebar/sidebar_white/lead_managment_white.svg'
          />

          <SidebarMenuItem
            to='/raise-tickets'
            icon='element-11'
            title='Raise a Ticket'
            imgSrc='assets/media/sidebar/raise_tickets.svg'
            whiteImgSrc='/assets/media/sidebar/sidebar_white/raise_tickets_white.svg'
          />
        </>
      )}
    </>
  )

}

export { SidebarMenuMain };
